import React from "react";
import "./upload.css";

function Upload() {
  return (
    <div className="upload-container">
      <h2>Select Uploading Option</h2>
      <div className="upload-options">
        <div className="option-category">
          <h3>Student</h3>
          <div className="option-card">Workshop</div>
          <div className="option-card">Workshop</div>
          <div className="option-card">Workshop</div>
        </div>
        <div className="option-category">
          <h3>Lawyer</h3>
          <div className="option-card">Workshop</div>
          <div className="option-card">Workshop</div>
        </div>
        <div className="option-category">
          <h3>Client</h3>
          <div className="option-card">Workshop</div>
          <div className="option-card">Workshop</div>
        </div>
      </div>
    </div>
  );
}

export default Upload;
